import styled from "styled-components";
import * as React from "react";
import Stack from "@mui/material/Stack";
import { DataGrid } from "@mui/x-data-grid";
import { GridActionsCellItem } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Alert } from "@mui/material";
import { createShortLink, deleteShortLink, getAllLink } from "../api/link";

const WrapperAlert = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  @keyframes showAlert {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
`;

const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  padding-top: 70px;
  padding-left: 70px;
  padding-right: 70px;
  margin-left: auto;
  margin-right: auto;
  background-color: #ffffff;
  background-repeat: repeat;
  position: unset;
  display: ${(props) => (props.show ? "none" : "block")};
  height: 100vh;
`;

const WrapperContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;
const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

function NoRowsOverlay() {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      <TextNoData>No Data</TextNoData>
    </Stack>
  );
}

function NoResultsOverlay() {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      <TextNoData>Not Found</TextNoData>
    </Stack>
  );
}

const ManageLink = () => {
  const [isVisible, setIsVisible] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [idDelete, setIdDelete] = React.useState(null);

  const [textError, setTextError] = React.useState("");
  const [typeError, setTypeError] = React.useState("success");
  const [dataLink, setDataLink] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [textLink, setTextLink] = React.useState("");
  const [textTitle, setTextTitle] = React.useState("");

  const columns = [
    { field: "_id", headerName: "ID", width: 70, flex: 1 },
    { field: "title", headerName: "Title", width: 70, flex: 1 },
    { field: "link", headerName: "Link", width: 130, flex: 2 },
    { field: "short_link", headerName: "Short Link", width: 130, flex: 2 },
    { field: "view_count", headerName: "View Count", width: 80, flex: 0.5 },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          // icon={<VisibilityIcon />}
          label="Go to"
          onClick={() =>
            window.open(
              `${window.location.origin}/link/${params.row.short_link}`,
              "_blank"
            )
          }
          showInMenu
        />,
        <GridActionsCellItem
          // icon={<VisibilityIcon />}
          label="Copy"
          onClick={() =>
            navigator.clipboard.writeText(
              `${window.location.origin}/link/${params.row.short_link}`
            )
          }
          showInMenu
        />,
        <GridActionsCellItem
          // icon={<VisibilityIcon />}
          label="Delete"
          onClick={() => {
            setOpenConfirm(true);
            setIdDelete(params.row._id);
          }}
          showInMenu
        />,
      ],
    },
  ];

  const handleDelete = () => {
    deleteShortLink(idDelete)
      .then(async (res) => {
        setTextError(`Delete Link Success`);
        setTypeError("success");
        setIsVisible(true);
        setOpenConfirm(false);
        setTimeout(() => {
          (async () => {
            await getAllLink()
              .then(async ({ data }) => {
                // setSampleDetail(data);
                setDataLink(data);
                setTextLink("");
                setTextTitle("");
                setOpenConfirm(false);
                setIsVisible(false);
              })
              .catch((err) => {
                console.log("error", err.message);
                setTextLink("");
                setTextTitle("");
                setOpenConfirm(false);
                setIsVisible(false);
              });
          })();
        }, 1500);
      })
      .catch((err) => {
        setTextLink("");
        setTextTitle("");
        setTextError("Error delete link");
        setTypeError("error");
        setOpenConfirm(false);
        setIsVisible(true);
        setTimeout(() => {
          setIsVisible(false);
        }, 1500);
      });
  };

  const handleClickOpen = () => {
    setOpen(true);
    setTextLink("");
    setTextTitle("");
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseComfirm = () => {
    setOpenConfirm(false);
  };

  const handleCreate = async () => {
    if (
      textTitle === "" ||
      textLink === "" ||
      textLink.includes("http") === false
    )
      return;
    createShortLink({ title: textTitle, link: textLink })
      .then((res) => {
        setOpen(false);
        setTextError("Create Short Link Success");
        setTypeError("success");
        setIsVisible(true);
        setTextLink("");
        setTextTitle("");
        setTimeout(() => {
          setIsVisible(false);
          (async () => {
            await getAllLink()
              .then(async ({ data }) => {
                // setSampleDetail(data);
                setDataLink(data);
                setTextLink("");
                setTextTitle("");
                setIsVisible(false);
              })
              .catch((err) => {
                console.log("error", err.message);
                setTextLink("");
                setTextTitle("");
                setIsVisible(false);
              });
          })();
        }, 1500);
      })
      .catch((err) => {
        setOpen(false);
        setTextLink("");
        setTextTitle("");
        setTextError(err.response.data.message);
        setTypeError("error");
        setIsVisible(true);
        setTimeout(() => {
          setIsVisible(false);
        }, 1500);
      });
  };

  React.useEffect(() => {
    (async () => {
      const { data } = await getAllLink();
      setDataLink(data);
      setIsLoading(false);
    })();
  }, []);

  return (
    <Container>
      <WrapperContent>
        <h1>Manage short Link</h1>
        <div>
          <Button variant="outlined" onClick={handleClickOpen}>
            Create New Short Link
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Create New Short Link?"}
            </DialogTitle>
            <DialogContent>
              <Box
                component="form"
                sx={{
                  "& > :not(style)": { m: 1, width: "25ch" },
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  id="outlined-basic-title"
                  label="input title"
                  variant="outlined"
                  value={textTitle}
                  onChange={(e) => setTextTitle(e.target.value)}
                />
                <TextField
                  id="outlined-basic"
                  label="new link"
                  variant="outlined"
                  value={textLink}
                  onChange={(e) => setTextLink(e.target.value)}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={handleCreate} autoFocus>
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openConfirm}
            onClose={handleCloseComfirm}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Delete Short Link?"}
            </DialogTitle>
            <DialogContent>
              <Box
                component="form"
                sx={{
                  "& > :not(style)": { m: 1, width: "25ch" },
                }}
                noValidate
                autoComplete="off"
              ></Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseComfirm}>Cancel</Button>
              <Button onClick={() => handleDelete()} autoFocus>
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div style={{ height: 500, padding: "20px 50px" }}>
          <DataGrid
            rows={dataLink}
            loading={isLoading}
            getRowId={(row) => row._id}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[10, 20]}
            components={{
              // Footer: CustomPagination,
              NoRowsOverlay,
              NoResultsOverlay,
            }}
          />
        </div>
      </WrapperContent>
      {isVisible && (
        <WrapperAlert>
          <DivAlert>
            <Alert className="MuiPaper-root-MuiAlert-root" severity={typeError}>
              {textError}
            </Alert>
          </DivAlert>
        </WrapperAlert>
      )}
    </Container>
  );
};

export default ManageLink;
